import React from "react";
import {useStyles, InfoSection} from "../../base/BaseLatestArtifactInfo.js"

export default function LatestArtifactInfo({ options }) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <InfoSection title="FRONTEND" data={options.latestFrontendUpdate} />
            <InfoSection title="BACKEND" data={options.latestBackendUpdate} />
        </div>
    );
}
